import Big from 'big.js'

export default function (value) {
  return precision => {
    const num = Number(value)

    return isNaN(num) ? '' : new Big(num).div(precision).toJSON()
  }
}